<template>
    <div class="oneRevDialogBox" @keyup.esc="modalClose">
        <div>
            <a title="Close" class="close" @click="closeBox">X</a>
            <h4>Introducing OneRevolution</h4>
            <hr />
        </div>
        <div class="clear"></div>
        <p>You can now find your pay stubs at our secure portal called <span class="fakelink" @click="gotoOneRev">OneRevolution</span>&mdash;protected with ID.me.</p>
        <div class="clear"></div>
        <hr />
        <div class="right">
            <span v-if="buttonYes">
                <button class="btn btn-primary m-right-10" @click="gotoOneRev"><span v-if="buttonYesLabel">{{buttonYesLabel}}</span><span v-else>Go to OneRevolution</span></button>
            </span>
            <span v-if="buttonNo">
                <button class="btn btn-default" @click="closeBox"><span v-if="buttonNoLabel">{{buttonNoLabel}}</span><span v-else>Close</span></button>
            </span>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
export default defineComponent ({
    name: 'OneRevolutionDialog',
    emits: ['close'],
    props: {
        buttonNo: {
            default: true
        },

        buttonYes: {
            default: true
        },

        buttonNoLabel: {
            type: String,
            required: false,
        },

        buttonYesLabel: {
            type: String,
            required: false,
        },
    },

    data() {
        return {}
    },

    methods: {
        closeBox(event) {
            this.$emit('close');
        },
        gotoOneRev() {
            this.$emit('close');
            window.open('https://onerevolution.com', '_blank');
        }
    },
    created() {
    },
    mounted () {
        if (this.reviews && this.reviews.length && this.reviews[0].comments) this.comments = this.reviews[0].comments;
    }
});
</script>

<style>
.oneRevDialogBox {
    position: absolute;
    top: 20%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    border: 2px solid red;
    border-radius: 10px;
    box-shadow: 2px 20px 40px 30px #666;
    padding: 20px;
    background-color: white;
    max-width: 600px;
    min-width: 500px;
}
.option {
    font-size: 1.1em;
    font-weight: bold;
    text-decoration: underline;
}
.info {
    font-weight: lighter;
}
</style>